import { useState, useCallback } from 'react';
import HandCarryListService from './handCarryService';

const useHandCarryList = (shopName) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [handCarryLists, setHandCarryLists] = useState([]);

  const fetchHandCarryLists = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await HandCarryListService.getHandCarryLists(shopName);
      setHandCarryLists(response.data);
    } catch (err) {
      setError(err.message || 'Failed to fetch hand carry lists');
      throw err;
    } finally {
      setLoading(false);
    }
  }, [shopName]);

  const registerHandCarryList = async (data) => {
    try {
      setLoading(true);
      setError(null);
      await HandCarryListService.registerHandCarryList(data);
      // Fetch updated list after successful registration
      await fetchHandCarryLists();
    } catch (err) {
      setError(err.message || 'Failed to register hand carry list');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const deleteHandCarryList = async (id) => {
    try {
      setLoading(true);
      setError(null);
      await HandCarryListService.deleteHandCarryList(id);
      // Fetch updated list after successful deletion
      await fetchHandCarryLists();
    } catch (err) {
      setError(err.message || 'Failed to delete hand carry list');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const checkHandCarryByUrl = async (url) => {
    try {
      setLoading(true);
      setError(null);
      const response = await HandCarryListService.checkHandCarryByUrl(url);
      return response.data;
    } catch (err) {
      setError(err.message || 'Failed to check hand carry status');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  // New functions
  const updateJpArriveDate = async (id, data) => {
    try {
      setLoading(true);
      setError(null);
      await HandCarryListService.updateJpArriveDate(id, data);
      // Fetch updated list after successful update
      await fetchHandCarryLists();
    } catch (err) {
      setError(err.message || 'Failed to update JP arrive date');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const updateHandCarryDate = async (id) => {
    try {
      setLoading(true);
      setError(null);
      await HandCarryListService.updateHandCarryDate(id);
      // Fetch updated list after successful update
      await fetchHandCarryLists();
    } catch (err) {
      setError(err.message || 'Failed to update hand carry date');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    handCarryLists,
    registerHandCarryList,
    deleteHandCarryList,
    fetchHandCarryLists,
    checkHandCarryByUrl,
    updateJpArriveDate,
    updateHandCarryDate,
  };
};

export default useHandCarryList;